import { lazy } from 'react';

const ResubmitRequests = lazy(() => import('../../admin/resubmit-requests/AdminResubmitPage'));

const ManagerResubmitConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/resubmit-requests',
      element: <ResubmitRequests />,
    },
  ],
};

export default ManagerResubmitConfig;
